module.exports = __webpack_public_path__ + "img/搜索.7d8eaa57.png";